import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API_PROPERTY } from 'src/@core/services/util/api.endpoints';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { Lightbox, LightboxConfig, IAlbum } from 'ngx-lightbox'; // Import Lightbox and LightboxConfig
import { AppService } from 'src/@core/services/app.service';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BookSocietyDialogComponent } from '../book-society-dialog/book-society-dialog.component';
import { environment } from 'src/environments/environment';
import { ViewUploadedImageComponent } from '../../employment/view-proof-of-work/view-uploaded-image/view-uploaded-image.component';



function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      // get a list of checkbox values (boolean)
      .map(control => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}

@Component({
  selector: 'hour4u-admin-view-society',
  templateUrl: './view-society.component.html',
  styleUrls: ['./view-society.component.scss']
})
export class ViewSocietyComponent implements OnInit {
  societies: any[] = [];
  society: any;
  timeDifference: string = '';
  tiles: any[] = [];
  societyId: string;
  baseImageUrl = environment.image_url
  imageUrls: string[] = []; // property to store image URLs
  albums: IAlbum[] = [];

  roles = roles;
  entityTypes = entityTypes;
  currentUserRole: any = null;
  public userEmail: string = '';
  form: FormGroup;
  numberOfHours: any;
  bookingForm: FormGroup;
  copiedSocieties: { [key: string]: boolean } = {};
  copyTitleSociety: string = 'Share';
  bookedSocieties: any[] = [];
  serviceAdded: boolean = false;
  isSubmitted: boolean = false;
  loaderColor: string;
  mode = 'indeterminate';
  isLoading: boolean = true;

  hoursList: any[] = [
    {
      id: 1,
      label: '1 hour'
    },
    {
      id: 2,
      label: '2 hours'
    },
    {
      id: 3,
      label: '3 hours'
    },
    {
      id: 4,
      label: '4 hours'
    },
    {
      id: 5,
      label: '5 hours'
    },
    {
      id: 6,
      label: '6 hours'
    },
    {
      id: 7,
      label: '7 hours'
    },
    {
      id: 8,
      label: '8 hours'
    },
    {
      id: 9,
      label: '9 hours'
    },
    {
      id: 10,
      label: '10 hours'
    },
    {
      id: 11,
      label: '11 hours'
    },
    {
      id: 12,
      label: '12 hours'
    }
  ];

  servicesList: any[] = [
    // {
    //   id: 0,
    //   label: 'Leaflet distribution',
    //   selected: false,
    // },
    // {
    //   id: 1,
    //   label: 'Gate marketing',
    //   selected: false,
    // },
    // {
    //   id: 2,
    //   label: 'WhatsApp marketing',
    //   selected: false,
    // }
    {
      id: 0,
      label: 'Venue Pemissions',
      selected: true,
    }
  ]
  servicesListArray: FormArray;
  times = this.generateTimeSlots();

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private lightbox: Lightbox, // Inject the Lightbox service
    private lightboxConfig: LightboxConfig, // Inject the LightboxConfig service
    private appService: AppService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.setupForm();
    // this.onChanges();
    // Retrieve the society ID from the route parameter
    this.route.params.subscribe((params) => {
      this.societyId = params['id'];

      // Fetch the society details using the societyId
      this.http.get<any>(`${API_PROPERTY}/${this.societyId}`).subscribe(
        (society) => {
          this.society = society;
          this.isLoading = false;
          this.calculateTimeDifference();

          //  fetch the image URLs based on society data
          if (this.society.images && this.society.images.length > 0) {
            this.imageUrls = this.society.images.map(
              (imagePath) =>
                `${this.baseImageUrl}${imagePath}`
            );

            // Populate the albums array with valid data
            this.imageUrls.forEach((imageUrl) => {
              if (imageUrl) { // Check if imageUrl is defined
                const album: IAlbum = {
                  src: imageUrl,
                  caption: '',
                  thumb: '',
                };
                this.albums.push(album);
              }
            });
          }
        },
        (error) => {
          this.isLoading = false;
          console.error('Failed to fetch society:', error);
        }
      );
    });

    // Configure the Lightbox
    this.lightboxConfig.centerVertically = true;
    this.lightboxConfig.disableScrolling = false;
    this.lightboxConfig.fadeDuration = 0.5;
    this.userEmail = this.appService.getCurrentAccount().email;
    this.getCurrentRole();
  }

  // setup booking form
  setupForm() {
    // const formControls = this.servicesList.map(control => new FormControl(false));
    // const selectAllControl = new FormControl(false);

    this.bookingForm = this.fb.group({
      numberOfHours: [4],
      bookingDate: ['', [Validators.required]],
      bookingTime: ['', [Validators.required]],
      // servicesListArray: this.fb.array([
      //   this.createService(),
      // ]),
      servicesListArray: new FormArray([], minSelectedCheckboxes(1)),
    });
    this.addCheckboxes();
  }

  // array specify
  get servicesListArrays(): FormArray {
    return this.bookingForm.get('servicesListArray') as FormArray;
  }

  private addCheckboxes() {
    this.servicesListArray = this.bookingForm.get('servicesListArray') as FormArray;
    this.servicesListArray.clear();
    this.servicesList.forEach(() => this.servicesListArray.push(new FormControl(true)));
  }

  createService(): FormGroup {
    return this.fb.group({
      id: [],
      label: [],
      selected: [false]
    });
  }

  // get current user role
  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
          console.log(this.currentUserRole)

          if (this.currentUserRole == 'ENTERPRISE_ADMIN' || this.currentUserRole == 'ENTERPRISE_STAFF') {
            this.bookingForm.controls['numberOfHours'].setValidators(Validators.required);
            this.bookingForm.controls['servicesListArray'].setValidators(Validators.required);
          } else {
            this.bookingForm.controls['numberOfHours'].setValidators([]);
            this.bookingForm.controls['servicesListArray'].setValidators([]);
          }
          this.bookingForm.controls['numberOfHours'].updateValueAndValidity();
          this.bookingForm.controls['servicesListArray'].updateValueAndValidity();
        })
      }
    })
  }

  // Function to open the lightbox
  openLightbox(index: number): void {
    this.lightbox.open(this.albums, index);
  }



  calculateTimeDifference() {
    if (this.society && this.society.availableSlots && this.society.availableSlots.length > 0) {
      const { timeFrom, timeTo } = this.society.availableSlots[0];
      if ((timeFrom && timeFrom.length) && (timeTo && timeTo.length)) {
        const hourDifference = timeTo[0] - timeFrom[0];
        const minuteDifference = timeTo[1] - timeFrom[1];

        this.timeDifference = `${hourDifference} h ${minuteDifference} m`;
      }
    } else {
      this.timeDifference = "N/A"; // Set a default value when data is not available
    }
  }


  editSociety(societyId: string) {
    // Navigate to the "add-edit-societies" route with the society ID in the route parameter
    this.router.navigate(['/societies/add-edit-societies', societyId]);
  }


  updateChkbxArray(event) {
    console.log(event)
  }

  openBookSocietyDialog() {
    this.isSubmitted = true;
    console.log(this.bookingForm)

    if (!this.bookingForm.valid) {
      this.bookingForm.markAllAsTouched();
      return;
    }

    let selectedServices: any;
    if (this.currentUserRole == 'ENTERPRISE_ADMIN' || this.currentUserRole == 'ENTERPRISE_STAFF') {
      console.log(this.bookingForm.value.servicesListArray)
      selectedServices = this.bookingForm.value.servicesListArray
        .map((checked, i) => checked ? this.servicesList[i] : null)
        .filter(v => v !== null);
      console.log(selectedServices)
      this.serviceAdded = false;
      if (selectedServices && selectedServices.length) {
        this.serviceAdded = true;
      } else {
        this.serviceAdded = false;
        return;
      }
    }

    const dialogRef = this.dialog.open(BookSocietyDialogComponent, {
      width: '488px',
      panelClass: 'add-edit-user-dialog',
      data: {
        society: this.society,
        numberOfHours: this.bookingForm.get('numberOfHours').value,
        bookingDate: this.bookingForm.get('bookingDate').value,
        bookingTime: this.bookingForm.get('bookingTime').value,
        services: selectedServices,
        formValue: this.bookingForm.value,
        currentUserRole: this.currentUserRole
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.addCheckboxes();
      this.bookingForm.controls['numberOfHours'].setValue(4);
      this.bookingForm.controls['bookingDate'].setValue("");
      this.bookingForm.controls['bookingTime'].setValue("");
      this.bookingForm.markAsUntouched();
    });
  }


  copySocietyLinkToClipboard(societyId: string) {
    let copyUrl = null;

    if (environment.api_url === 'https://devapi.hour4u.com') {
      copyUrl = `https://dev.workorbits.com/venues/view-venue/${societyId}`;
    }
    if (environment.api_url === 'https://api.hour4u.com') {
      copyUrl = `https://workorbits.com/venues/view-venue/${societyId}`;
    }

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyUrl || '';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    // Update the local state to mark the society's link as copied
    this.copiedSocieties[societyId] = true;

    // Reset the button text after a specific duration (e.g., 3 seconds)
    setTimeout(() => {
      this.copiedSocieties[societyId] = false;
    }, 5000);
  }

  viewUploadedImage(element: any) {
    if (element) {
      const imagePath = element;
      const dialogRef = this.dialog.open(ViewUploadedImageComponent, {
        width: '1024px',
        panelClass: 'add-edit-user-dialog',
        disableClose: true,
        data: {
          imageUrl: imagePath,
          selectedTask: element,
          title: 'View venue picture'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.ngOnInit();
        }
      });
    } else {
      console.error('Image URL not available.');
    }
  }

  generateTimeSlots(selectedStartTime?: string, selectedEndTime?: string): {
    timeDifference: string; display: string, value: string
  }[] {
    const times: {
      timeDifference: string; display: string, value: string
    }[] = [];

    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hour12 = ('0' + (h % 12 || 12)).slice(-2); // Convert 0 to 12 for 12-hour format
        const hour24 = ('0' + h).slice(-2); // 24-hour format
        const minute = ('0' + m).slice(-2);
        const period = h < 12 ? 'AM' : 'PM';

        const displayFormat = `${hour12}:${minute} ${period}`;
        const valueFormat = `${hour24}:${minute}`;

        times.push({
          display: displayFormat, value: valueFormat,
          timeDifference: ''
        });
      }
    }
    times.forEach(time => {
      // Calculate time difference for each time option
      // ... calculate time difference based on your logic
      time.timeDifference = '';// assign the calculated time difference
    });
    return times;
  }
}